import {mapActions, mapGetters, mapMutations} from 'vuex'

export const encodingProfileMixin = {
  computed: {
    ...mapGetters({
      'encodingProfiles': 'encodingProfiles/all',
      'encodingProfile': 'encodingProfiles/encodingProfile'
    })
  },
  methods: {
    ...mapActions({
      'getEncodingProfiles': 'encodingProfiles/getEncodingProfiles',
      'updateEncodingProfile': 'encodingProfiles/updateEncodingProfile',
      'deleteEncodingProfile': 'encodingProfiles/deleteEncodingProfile',
      'addEncodingProfile': 'encodingProfiles/addEncodingProfile',
      'cloneEncodingProfile': 'encodingProfiles/cloneEncodingProfile',
      'assignEncodingProfile': 'encodingProfiles/assignEncodingProfile'
    }),
    ...mapMutations({
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/encodingProfileMixin.js